import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { FormControl, FormGroup } from '@angular/forms';
import { FormValidatorService } from '../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../shared/validators';
import { BehaviorSubjectConfirmationService } from '../../../../../shared/services/behavior-subject-confirmation.service';
import { CCFetchBusinessDataService } from '../../services/ccfetch-business-data.service';
import { ChangeContractStatusService } from '../../services/sign-contract.service';
import { SaveContractDataService } from '../../services/save-contract-data.service';
import { FetchContractDataService } from '../../services/fetch-contract-data.service';
import * as cities from '../../../../../../assets/eg.json';
import { templates } from '../../../../../shared/contract-template';
import * as html2pdf from 'html2pdf.js';
import { asBlob } from 'html-docx-js-typescript';
import { saveAs } from 'file-saver-es';
import { ContractStatusNotifierService } from '../../services/contractStatusNotifier.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';
import { CONSTANT_CUSTOMER_SUPPORT_INFO } from 'src/app/shared/ConstantCustomerSupportInfo';
import { CONTRACT_STATUSES } from 'src/app/shared/services/ContractStatuses';
import { AuthService } from 'src/app/shared/services/auth.service';


@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent implements OnInit, AfterViewInit {
  fvPage1 = new FormValidatorService();
  fvPage2 = new FormValidatorService();
  fvPage3 = new FormValidatorService();
  page1Form!: FormGroup;
  page2Form!: FormGroup;
  page3Form!: FormGroup;
  isAdmin: boolean = false;
  subscriptions: Subscription[] = [];
  @Input() ViewRequestData: any;
  @Input() ViewRequestFlag: boolean= false;
  @Input() RequestIsPending: boolean = false;
  saveError: any;
  cities: any;
  busniessCreatedAt: any;
  bankAccounts: any;
  header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "xmlns='http://www.w3.org/TR/REC-html40'>" +
    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
  footer = "</body></html>";
  showContractAlert: boolean  = false;
  contractBussinessOwner: string = '';
  contractBodySeller: string = '';
  contractStatus = new FormControl();
  hasBusinessRegistered = null;
  contractBussinessOwnerTemplate: string = templates.contractBussinessOwner;
  contractBodySellerTemplate: string = templates.contractBodySeller;
  checkBankAccountIfAvailable: boolean = true;
  CustomerSupportPhone: string = CONSTANT_CUSTOMER_SUPPORT_INFO.phone;
  oldData : any;
  isSubmitted : boolean = false ;
  pattern = "^[0-9-]*";

  constructor(
    private fetchBusinessData: CCFetchBusinessDataService,
    private saveContractData: SaveContractDataService,
    private fetchContractData: FetchContractDataService,
    private behaviourSubjectContract: BehaviorSubjectConfirmationService,
    private router: Router,
    private httpClient: HttpClient,
    public sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private changeContractStatusService: ChangeContractStatusService,
    private contractServNotifier: ContractStatusNotifierService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private auth: AuthService,
  ) { }

  async ngOnInit() {

    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);

    })
    this.isAdmin = !!(await this.auth.getBusiness());
    this.cities = (cities as any).default;

    this.page1Form = this.fvPage1.createForm([
      {
        fieldName: 'businessName',
        defaultValue: null,
      },
      {
        fieldName: 'email',
        defaultValue: null,
      },
      {
        fieldName: 'phoneNumber',
        defaultValue: null,
      },
      {
        fieldName: 'contractDeliveryGovernate',
        defaultValue: null
      },
      {
        fieldName: 'contractDeliveryArea',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'contractDeliveryAddress',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'contractDeliveryDuration',
        defaultValue: null
      }
    ]);

    this.page2Form = this.fvPage2.createForm([
      {
        fieldName: "exactRegisterName",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: "commericalRegisterNumber",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: "registeredBusinessAddress",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: "taxRegistrationNumber",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: 'this field should not be empty'
          },
          {
            validatorFn: Validators.pattern(this.pattern),
            message: 'Tax Registration Number must be numbers',
          },
          {
            validatorFn: Validators.maxLength(11),
            message: 'Tax Registration Number should be 9 numbers',
          },
          {
            validatorFn: Validators.minLength(11),
            message: 'Tax Registration Number should be 9 numbers',
          }
        ]
      },
      {
        fieldName: "businessOwnerFullName",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: "businessOwnerNationalID",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'businessName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
    ]);

    this.page3Form = this.fvPage3.createForm([
      {
        fieldName: 'fullName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'businessName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'nationalID',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      }
    ]);
    let id: number = this.ViewRequestData ? this.ViewRequestData.BusinessId : null;
    this.getViewData(id)
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.fvPage1.validationMessages = {
        "contractDeliveryArea": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Delivery Area',
            fieldAr: 'منطقة التسليم'
          }),
        },
        "contractDeliveryAddress": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Delivery Address',
            fieldAr: 'عنوان التسليم'
          }),
        },
      }
      this.fvPage2.validationMessages = {
        "exactRegisterName": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Exact registered business name',
            fieldAr: 'الاسم التجاري المسجل بالضبط'
          }),
        },
        "commericalRegisterNumber": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Commercial register number',
            fieldAr: 'رقم السجل التجاري'
          }),
        },
        "registeredBusinessAddress": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Registered business address',
            fieldAr: 'عنوان العمل المسجل'
          }),
        },
        "taxRegistrationNumber": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Registered business address',
            fieldAr: 'عنوان العمل المسجل'
          }),
        },
        "businessOwnerFullName": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business owner full name',
            fieldAr: 'الاسم الكامل لصاحب العمل'
          }),
        },
        "businessOwnerNationalID": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business owner national id number',
            fieldAr: 'الرقم القومي لصاحب العمل'
          }),
        },
      }
      this.fvPage3.validationMessages = {
        "fullName": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Full name',
            fieldAr: 'الاسم بالكامل'
          }),
        },
        "businessName": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business Name',
            fieldAr: 'الاسم التجاري'
          }),
        },
        "nationalID": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'National id number',
            fieldAr: 'الرقم القومي'
          }),
        },
      }
    });
  }

  async getViewData(id :number){
    if (this.ViewRequestFlag) {
      this.fetchBusinessData.setParams({ businessId: id, isAdmin: true });
      this.fetchContractData.setParams({ businessId: id, isAdmin: true });
      this.page1Form.disable();
      this.page2Form.disable();
      this.page3Form.disable();
      this.page2Form.controls['taxRegistrationNumber'].enable();
    }

    const businessData = await this.fetchBusinessData.make();
    moment.locale('ar')
    this.busniessCreatedAt = moment(businessData.createdAt).format('L');
    this.page1Form.controls['businessName'].setValue(businessData.name);
    this.page1Form.controls['email'].setValue(businessData.Users[0].email);
    this.page1Form.controls['phoneNumber'].setValue(businessData.Users[0].phone);
    this.contractStatus.setValue(businessData.contractStatus);
    if(businessData.contractStatus) this.hasBusinessRegistered = null;

    const oldContractData = await this.fetchContractData.make();
    this.oldData = oldContractData

    if (oldContractData.BusinessId) {
      this.perparingTheBankTable(oldContractData.Business.BankAccounts)
      this.hasBusinessRegistered = oldContractData.hasRegisteredBusiness;
      this.page1Form.controls['contractDeliveryGovernate'].setValue(oldContractData.contractDeliveryGovernate);
      this.page1Form.controls['contractDeliveryArea'].setValue(oldContractData.contractDeliveryArea);
      this.page1Form.controls['contractDeliveryAddress'].setValue(oldContractData.contractDeliveryAddress);
      this.page1Form.controls['contractDeliveryDuration'].setValue(oldContractData.contractDeliveryDuration);

      this.page2Form.controls['commericalRegisterNumber'].setValue(oldContractData.commericalRegisterNumber);
      this.page2Form.controls['exactRegisterName'].setValue(oldContractData.exactRegisterName);
      this.page2Form.controls['registeredBusinessAddress'].setValue(oldContractData.registeredBusinessAddress);
      this.page2Form.controls['taxRegistrationNumber'].setValue(oldContractData.taxRegistrationNumber);
      this.page2Form.controls['businessOwnerFullName'].setValue(oldContractData.businessOwnerFullName);
      this.page2Form.controls['businessOwnerNationalID'].setValue(oldContractData.businessOwnerNationalID);
      this.page2Form.controls['businessName'].setValue(businessData.name);

      this.page3Form.controls['fullName'].setValue(oldContractData.fullName);
      this.page3Form.controls['nationalID'].setValue(oldContractData.nationalID);
      this.page3Form.controls['businessName'].setValue(businessData.name);

    }else {
      this.hasBusinessRegistered = null
      this.bankAccounts = ''

      this.page1Form.controls['contractDeliveryGovernate'].setValue('');
      this.page1Form.controls['contractDeliveryArea'].setValue('');
      this.page1Form.controls['contractDeliveryAddress'].setValue('');
      this.page1Form.controls['contractDeliveryDuration'].setValue('');

      this.page2Form.controls['commericalRegisterNumber'].setValue('');
      this.page2Form.controls['exactRegisterName'].setValue('');
      this.page2Form.controls['registeredBusinessAddress'].setValue('');
      this.page2Form.controls['businessOwnerFullName'].setValue('');
      this.page2Form.controls['businessOwnerNationalID'].setValue('');
      this.page2Form.controls['businessName'].setValue('');

      this.page3Form.controls['fullName'].setValue('');
      this.page3Form.controls['nationalID'].setValue('');
      this.page3Form.controls['businessName'].setValue('');

    }

	  let taxRegistrationNumber: string =
		  this.page2Form.get('taxRegistrationNumber').value;
    if (taxRegistrationNumber){
        taxRegistrationNumber = this.FormatTaxRegistrationNumber(taxRegistrationNumber);
	      this.page2Form.patchValue({ taxRegistrationNumber });
     }

      }

  async nextOrSubmit() {
    this.checkBankAcounts();
    if (this.checkBankAccountIfAvailable){
      this.submit(false);
    }
  }

  perparingTheBankTable(bankAccounts: [any]) {
    let body;
    let trs = [];
    for (const acc of bankAccounts) {
      let record = `<tr>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.holder_name}</td>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.Branch?.Bank.arabic_bank_name}</td>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.Branch?.arabic_branch_name}</td>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.account_number}</td>
      </tr>`
      trs.push(record)
    }
    body = trs.join();
    this.bankAccounts = body;
  }

  exportAs(type: string) {
    window.scrollTo(0, 0);
    var element = document.createElement('page');
    element.style.color = "black";
    if (this.hasBusinessRegistered) {
      this.contractBussinessOwner = this.contractBussinessOwnerTemplate
        .replace('EMAIL_PLACEHOLDER', this.page1Form.controls['email'].value)
        .replace('DATE_PLACEHOLDER', this.busniessCreatedAt)
        .replace('ACC_NAME_PLACEHOLDER', this.page1Form.controls['businessName'].value)
        .replace('BANK_ACCOUNTS_PLACEHOLDERS', this.bankAccounts)
        .replace('PHONE_PLACEHOLDER', this.page1Form.controls['phoneNumber'].value)
        .replace('REGISTERED_BUSINESS_NAMAE', this.page2Form.controls['exactRegisterName'].value)
        .replace('COMMERICAL_NUMBER_PLACEHOLDER', this.page2Form.controls['commericalRegisterNumber'].value)
        .replace('BUSINESS_OWNER_NAME', this.page2Form.controls['businessOwnerFullName'].value);
      element.innerHTML = this.contractBussinessOwner;
    }
    else {
      this.contractBodySeller = this.contractBodySellerTemplate
        .replace('NAME_PLACEHOLDER', this.page3Form.controls['fullName'].value)
        .replace('DATE_PLACEHOLDER', this.busniessCreatedAt)
        .replace('ID_PLACEHOLDER', this.page3Form.controls['nationalID'].value)
        .replace('BANK_ACCOUNTS_PLACEHOLDERS', this.bankAccounts)
        .replace('EMAIL_PLACEHOLDER', this.page1Form.controls['email'].value)
        .replace('ACC_NAME_PLACEHOLDER', this.page1Form.controls['businessName'].value)
        .replace('PHONE_PLACEHOLDER', this.page1Form.controls['phoneNumber'].value);
      element.innerHTML = this.contractBodySeller;
    }
    type == 'pdf' ? this.toPDF(element) : this.toDoc(element.innerHTML);
  }

  toPDF(element: any) {
    var opt = {
      margin: 5,
      filename: 'contract.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 1, dpi: 192, letterRendering: true },
      jsPDF: { format: 'a4' }
    };
    html2pdf().set(opt).from(element).save();
  }

  async toDoc(element: any) {
    let content = [this.header, element, this.footer];
    const htmlString = content.join(' ');
    const data: any = await asBlob(htmlString, {});
    saveAs(data, 'contract.docx');
  }

  async confirmContract() {
    this.checkBankAcounts();
    if (this.checkBankAccountIfAvailable) {
      await this.submit(true);
      this.router.navigate(['/']);
    }
  }

  async accept(status: any) {

    if (!this.bankAccounts){
      this.showMessage(this.translate.instant('Sellers.Products.NoBankAccount'))
    }
    if (this.page1Form.invalid || (this.hasBusinessRegistered && this.page2Form.invalid) || this.page3Form.invalid) {
      this.fvPage1?.forceShowErrors();
      this.fvPage2?.forceShowErrors();
      this.fvPage3?.forceShowErrors();
      return;
    }
    if(this.isTaxNumberChanged() && !this.isSubmitted){
        this.showMessage(this.translate.instant('Sellers.Dashboard.SubmitContractChanges'))
      }
    else {
     this.changeStatusOfCntract(status);
     this.router.navigate(["/admin/requests/contracts"]);
    }
  }
  isTaxNumberChanged(): boolean {
    const taxRegistrationNumber = this.page2Form.get('taxRegistrationNumber').value;
    if (!taxRegistrationNumber) return false;
    const newTaxNumber = this.UnFormatTaxRegistrationNumber(taxRegistrationNumber);
    return this.oldData.taxRegistrationNumber !== newTaxNumber;
  }

  get isContractSubmitted(){
    return this.contractStatus.value==CONTRACT_STATUSES.value.SUBMITTED;
  }
  async requestEdit(){
    await this.changeStatusOfCntract(CONTRACT_STATUSES.value.SUBMITTED);
  }
  private async changeStatusOfCntract(status){
    this.changeContractStatusService.setParams({
      businessId: this.ViewRequestData.BusinessId,
      status,
    });
    await this.changeContractStatusService.make();
    this.contractStatus.setValue(status);
    this.showMessage(this.translate.instant('Sellers.Products.BusinesContracts', {
      status: status
    }));
  }
  async submit(confirmContract: boolean) {
    try {
      if (this.page1Form.invalid) {
        this.fvPage1.forceShowErrors();
        return;
      }
      if (this.hasBusinessRegistered) {
        if (this.page2Form.invalid) {
          this.fvPage2.forceShowErrors();
          return;
        }
      } else {
        if (this.page3Form.invalid) {
          this.fvPage3.forceShowErrors();
          return;
        }
      }
      this.isSubmitted =false ;
      const formData = new FormData();

	  let taxRegistrationNumber: string =
		  this.page2Form.get('taxRegistrationNumber')?.value;

      if(taxRegistrationNumber){
        taxRegistrationNumber = this.UnFormatTaxRegistrationNumber(taxRegistrationNumber);
	      this.page2Form.patchValue({ taxRegistrationNumber });
      }


      const outputObject = { ...this.page1Form.value, ...this.page2Form.value, ...this.page3Form.value };
      if (confirmContract) outputObject.confirm = true;
      for (const name of Object.keys(outputObject)) {
        if (outputObject[name])
          formData.append(name, outputObject[name]);
      }
      formData.append('businessId', this.ViewRequestData.BusinessId);
      this.saveContractData.setParams(formData);
      await this.saveContractData.make();
      this.showContractAlert = true;
      const businessData = await this.fetchBusinessData.make();
      this.isSubmitted =true ;
      //Service Created To Let The Contract Verification Step Recieve The Changes When The Contract Form is Submitted
      //The Push Status Function Emits The Value to The Contract Steps
      this.contractServNotifier.pushStatusNotification(businessData.contractStatus);

      if(taxRegistrationNumber){
        taxRegistrationNumber = this.FormatTaxRegistrationNumber(taxRegistrationNumber);
	      this.page2Form.patchValue({ taxRegistrationNumber });
      }


	  await this.changeStatusOfCntract(CONTRACT_STATUSES.value.CONFIRMED);
    } catch (error) {
      console.log("error: ", error);
      this.isSubmitted =false ;
      this.saveError = error.message || error.faultyRequest.error.error;
    }
  }

  download(url: any, saveName: any) {
    let extension = url.split('.')
    extension = extension[extension.length - 1]
    return this.httpClient.get(url,
      { responseType: 'blob' }).subscribe((data) => {
        var blob = new Blob([data]);
        saveAs(blob, `${saveName}.${extension}`);
      });
  }

  async updateBusinessLocalStorage(status: any) {
    this.behaviourSubjectContract.renderData.next(true);
    const business = await this.auth.getBusiness();
    business.contractStatus = status;
    this.auth.setBusiness(business);
  }

  checkBankAcounts() {
    if (!this.bankAccounts) {
      this.snackBar.open(this.translate.instant('Sellers.Products.AddBankAccount'), '', {
        duration: 3000
      });
      this.showMessage(this.translate.instant('Sellers.Products.AddBankAccount'))
      this.checkBankAccountIfAvailable = false;
    }
  }

  async nextOrPrevious(action:string){
    let id:number = this.ViewRequestData.id;
    if(action == 'next'){
      id = id+1;
      this.router.navigate([`/seller/settings/contract/${id}`]);
    }else{
      id = id-1;
      this.router.navigate([`/seller/settings/contract/${id}`]);
    }
  }
  ngOnChanges(){
    this.getViewData(this.ViewRequestData.BusinessId);
  }

  showMessage(message: string) {
    this.snackBar.open(message, null, {
      duration: 3000,
    });
  }

  convertPage1Controls(name: string) {
    return this.page1Form.get(name) as FormControl;
  }

  convertPage2Controls(name: string) {
    return this.page2Form.get(name) as FormControl;
  }

  convertPage3Controls(name: string) {
    return this.page3Form.get(name) as FormControl;
  }

  formatTaxRegistrationNumber() {
	  let num: string = this.page2Form.get('taxRegistrationNumber').value;
	  num = this.UnFormatTaxRegistrationNumber(num);
	  num = this.FormatTaxRegistrationNumber(num);
	  this.page2Form.patchValue({ taxRegistrationNumber: num });
  }

  private FormatTaxRegistrationNumber(num: string): string {
	  return num.replace(/\B(?=(\d{3})+(?!\d))/g, "-");
  }

  private UnFormatTaxRegistrationNumber(num: string): string {
	  return num.replace(/-/g, '');
  }
}
